namespace GeniuzPOS.CustomReport {
    export class ReportCusStockOnHandColumns {
        static columnsKey = 'CustomReport.ReportCusStockOnHand';
    }
}
